import { render, staticRenderFns } from "./PolicyRow.vue?vue&type=template&id=c1ccb124&scoped=true&"
import script from "./PolicyRow.vue?vue&type=script&lang=js&"
export * from "./PolicyRow.vue?vue&type=script&lang=js&"
import style0 from "./PolicyRow.vue?vue&type=style&index=0&id=c1ccb124&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1ccb124",
  null
  
)

export default component.exports